import jsonData from "./data.json";
import { ResponseType, emptyError } from "../Types/ServicesType/servicesType";
import {
  ComplaintsDropdownType,
  ComplaintsPayloadType,
  ComplaintsType,
  ConsultationCodeType,
  ConsultationDetailsType,
  HpiType,
  VistTypeType,
} from "./components/Complaints/types";
import {
  AllergenType,
  AllergySeverityType,
  AllergyStatusType,
  AllergyDropdownType,
  postAllergy,
} from "./components/Allergy/types";
import {
  BodySystemListType,
  PhysicalExaminationListType,
  PhysicalExaminationParams,
  RosType,
  SavePhysicalExamination,
  SavePhysicalExaminationParamsType,
} from "./components/PhysicalExamination/types";
import {
  DiagnosisListType,
  DiagnosisPayload,
  IcdCodeTypes,
} from "./components/Diagnosis/types";
import {
  // CptCodeSearchType,
  // CptCodeType,
  // CptRateType,
  FetchPatientShareParamType,
  // GetProcedureParams,
  PatientRateType,
  // PrescriptionDeletePayload,
  // ProcedureTableType,
  ProcedureType,
} from "./components/Procedures/types";
import {
  DosageTimingType,
  DrugFrequencyType,
  DrugType,
  DrugunitType,
  PrescriptionPayloadType,
  RouteOfAdminType,
} from "./components/Prescription/types";

import api, { access_token } from "../services/apiList";
const { emr, patientBookingApi,MastersApi } = api;
import { PostFamilyHistoryType } from "./components/History/FamilyHistory/type";
import {
  LogFieldType,
  LogResponseType,
  // PriorApprovalLisType,
  PriorApprovalSubmitParamsType,
  ViewVitalsType,
} from "./components/layouts/types";

import moment from "moment";
import {
  CptInvestigationRateType,
  GetLabPayloadType,
  GetPatientResponse,
  GetPatientShareParams,
  LabTableType,
  LabType,
  RadiologyTableType,
  RadiologyType,
} from "./components/Investigation/types";
import {
  LifeCycleStatusType,
  postSocialHistoryType,
  snomedDescriptionType,
  SocialHabitCategoryType,
  socialQuantityType,
} from "./components/History/socialHistory/type";
import { DiagType } from "./components/Problems/type";
import { EmrListParams, EmrListResponseType } from "./EmrLanding/types";
import {
  ClinicalImpressionSaveType,
  ClinicalImpresssionParamsType,
  GetClinicalImpressionType,
  GetManagementPlanType,
  GetTretmantPlanType,
  ManagementPlanParamsType,
  ManagementPlanSaveType,
  TreatmentPlanParamsType,
  TreatmentPlanSaveType,
} from "./components/ManagementPlan/types";
import {
  AddDieaseFormType,
  AddDieaseType,
  AddMedicalHistoryFormType,
  DiseaseType,
  MedicalHistoryListType,
  // MedicalHistoryLogType,
  SecondMedicalHistoryFormType,
  SecondSaveType,
} from "./components/History/medicalHistory/types";
import {
  ActivityList,
  ActivityListParamsType,
  ActivityPostParamsType,
  ActivityPostType,
  ViewFileParamsType,
  ViewFileResultType,
} from "./components/Activity/types";
import {
  DocumentDropdownType,
  DocumentsListType,
  SaveDocumentPayloadType,
} from "./components/UploadDocuments/types";
import {
  dentaCptDetailsType,
  DentalCptPayload,
  DentalRecords,
} from "./components/DentalProcedures/components/DentalForm/components/Types";
import { SubmitResponseType } from "../Insurance/ClaimListing/types";
import {
  ActivitySearchParamsType,
  ActivitySearchResponseType,
  submitEmrType,
} from "./types";
import instance from "@services/services";
import { getConstants } from "@utilifiles/methods/storage/storage";
import { createdById } from "../constants";

const { clinicId, userType, user } = getConstants();
const sampleResult: Omit<ResponseType<any>, "response"> = {
  responseIndicator: "success",
  responseMessage: "Success",
  statusCode: "200",
};
const errorResponse: Omit<ResponseType<any>, "response"> = {
  responseIndicator: "fail",
  responseMessage: "Something went wrong",
  statusCode: "500",
};

export const triggerHl7Messge = async ({
  encounterId,
  trigger,
}: {
  encounterId: number;
  trigger: string;
}): Promise<ResponseType<any>> => {
  try {
    const body = {
      encounterId,
      trigger,
      createdById,
    };
    const resut = (await instance.post(emr.hl7Trigger, body)).data;
    return resut;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getConsultationCode = async (data: {
  groupId: number;
  search: string;
  clinicId: number;
}): Promise<ResponseType<ConsultationCodeType[]>> => {
  const result = await instance.post(emr.getConsultationCode, data);
  return result.data;
};

export const getComplaints = async (
  id: string
): Promise<ResponseType<ComplaintsType[]>> => {
  try {
    const result = (
      await instance.get(`${emr.getComplaints}${id}?clinicId=${clinicId}`)
    ).data;
    return result;
  } catch (error) {
    return { ...errorResponse, response: [] };
  }
};

export const getComplaintsMaster = async (
  text: string
): Promise<ResponseType<ComplaintsDropdownType[]>> => {
  try {
    const result = (
      await instance.get(
        `${emr.getComplaintsMaster}${clinicId}?searchText=${text}`
      )
    ).data;
    return result;
  } catch (error) {
    return { ...errorResponse, response: [] };
  }
};

export const getHpi = async (): Promise<ResponseType<HpiType[]>> => {
  try {
    const result = (await instance.get(`${emr.getHpi}${clinicId}`)).data;
    return result;
  } catch (error) {
    return { ...errorResponse, response: [] };
  }
};

export const getConcultationDetails = async (
  id: string
): Promise<ResponseType<ConsultationDetailsType | null>> => {
  const result = await instance.get(
    `${emr.getConsultationDetails}${clinicId}?encounterId=${id}`
  );
  return result.data;
};

export const updateConsultation = async (body: {
  clinicId: number;
  encounterId: number;
  cptId: number | null;
  visitType: number;
}) => {
  try {
    const result = await instance.post(emr.updateConsultation, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const saveOrUpdateComplaints = async (
  params: Omit<
    ComplaintsPayloadType,
    "clinicId" | "createdDate" | "createdId" | "userType"
  >
): Promise<ResponseType<ComplaintsPayloadType | null>> => {
  const body: ComplaintsPayloadType = {
    ...params,
    clinicId,
    userType,
    createdDate: moment().format("YYYY-MM-DD"),
    createdId: createdById as number,
  };

  try {
    const result = (await instance.post(emr.saveComplaints, body)).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const deleteComplaints = async (
  id: number
): Promise<ResponseType<string>> => {
  try {
    const result = (
      await instance.get(`${emr.deleteComplaints}${id}?clinicId=${clinicId}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: "Somethig went wrong",
    };
  }
};

export const getVisitType = async (): Promise<ResponseType<VistTypeType[]>> => {
  const result = await instance.get(
    `${patientBookingApi.visitType}${clinicId}`
  );
  return result.data;
};

// export const getAllergyType = async (): Promise<
//   ResponseType<AlleryDropdownType[]>
// > => {
//   return {
//     ...sampleResult,
//     response: jsonData.allergyType,
//   };
// };

// physical examination

export const getPhysicalExamination = async (
  id: string
): Promise<ResponseType<PhysicalExaminationListType[]>> => {
  try {
    const result = (
      await instance.get(
        `${emr.getPhysicalExamination}${id}?clinicId=${clinicId}`
      )
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const getRosFieldData = async (
  id: string
): Promise<ResponseType<any[]>> => {
  try {
    const result = (
      await instance.get(`${emr.getRosFieldList}${id}?clinicId=${clinicId}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const postPhySicalExamination = async (
  data: PhysicalExaminationParams[]
): Promise<ResponseType<PhysicalExaminationParams | null>> => {
  try {
    const response = (await instance.post(emr.postPhysicalExamination, data))
      .data;
    return {
      ...sampleResult,
      response,
    };
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const deleteFirstPhysicalExamination = async (
  id: number
): Promise<ResponseType<any>> => {
  try {
    const result = (
      await instance.get(
        `${emr.deleteFirstPhysicalExamination}${id}?clinicId=${clinicId}`
      )
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const postSecontPhySicalExamination = async (
  data: PhysicalExaminationParams[]
): Promise<ResponseType<PhysicalExaminationParams | null>> => {
  try {
    const response = (
      await instance.post(emr.postSecondPhysicalExamination, data)
    ).data;
    return {
      ...sampleResult,
      response,
    };
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const removePhysicalExamination = async (
  id: number
): Promise<ResponseType<string>> => {
  try {
    const result = (
      await instance.get(
        `${emr.removePhysicalExamination}${id}?clinicId=${clinicId}`
      )
    ).data;
    return {
      ...sampleResult,
      response: result || "",
    };
  } catch (error) {
    return {
      ...errorResponse,
      response: "Something went wrong",
    };
  }
};

export const getBodySystemList = async (): Promise<
  ResponseType<BodySystemListType[]>
> => {
  const result = await instance.get(`${emr.getBodySystemList}${clinicId}`);
  return result.data;
};

export const getRosBs = async ({
  id,
  text,
}: {
  id: number;
  text: string;
}): Promise<ResponseType<RosType[]>> => {
      const result = (
      await instance.get(
        `${emr.getRosBs}${clinicId}?searchText=${text}&bodySystemId=${id}`
      )
    ).data;
     if(Boolean(result.response) && result.response.length === 0){
      return {
        ...result,
        response: [
          {
            rosName: text,
            rosId: 0,
            physicalExamId: null,
            bodySystemId:id
          },
        ],
      }
    }
    return result;
};

export const getRosLogs = async (): Promise<ResponseType<any[]>> => {
  const response = jsonData.rosLogDetails;
  return await new Promise((res, _) => {
    setTimeout(() => {
      res({
        ...sampleResult,
        response,
      });
    }, 500);
  });
};

export const postPhysicalExamination = async (
  params: SavePhysicalExaminationParamsType
): Promise<ResponseType<SavePhysicalExamination | null>> => {
  const body = {
    ...params,
    clinicId,
    createdById,
    createdDate: moment().format("YYYY-MM-DD"),
    userType,
  };
  try {
    const result = (await instance.post(`${emr.postPhysicalExamination}`, body))
      .data;
    return result;
  } catch {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getIcdCodes = async (
  code: string
): Promise<ResponseType<IcdCodeTypes[]>> => {
  try {
    const result = (
      await instance.get(`${emr.getIcdCodes}${clinicId}?code=${code}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const saveOrUpdateDignosis = async (
  params: DiagnosisPayload
): Promise<ResponseType<string>> => {
  console.log(params);

  const body = {
    ...params,
    isActive: params.isActive ? 1 : 0,
    active: params.isActive,
    clinicId,
    createdId: createdById,
    userType,
  };
  try {
    const result = (await instance.post(`${emr.postDiagnosis}`, body)).data;
    console.log("resultresultresult:::::::::::::::::::::result",result);
    return result;
  } catch (error) {
    console.log(error);
    return {
      ...errorResponse,
      response: "",
    };
  }
};

export const AddMedicalHistoryDisease = async (
  params: AddDieaseFormType
): Promise<ResponseType<AddDieaseType | null>> => {
  const body: AddDieaseType = {
    ...params,
    diseaseClinicId: clinicId,
    diseaseCreatedById: createdById as number,
    diseaseStatus: 1,
    diseaseCreatedByDate: `${moment().format("YYYY-MM-DD")} ${moment().format("hh:mm")}:00`,
  };
  try {
    const response = (await instance.post(emr.postMedicalHistoryDisease, body))
      .data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const AddMedicalHistory = async (
  params: AddMedicalHistoryFormType
): Promise<ResponseType<MedicalHistoryListType | null>> => {
  const body: MedicalHistoryListType = {
    ...params,
    clinicId,
    createdById: createdById as number,
    status: 1,
    userType: userType,
    isModified: Boolean(params.id) ? 1 : 0,
    revertFlag: false,
  };
  try {
    const response = (await instance.post(emr.postMedicalHistory, body)).data;
    return response;
    // return {
    //   ...sampleResult,
    //   response:null
    // }
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getMedicalHistory = async (
  id: string
): Promise<ResponseType<MedicalHistoryListType[]>> => {
  try {
    const response = (
      await instance.get(`${emr.getMedicalHistory}${id}?clinicId=${clinicId}`)
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const deleteMedicalHistory = async (
  id: string
): Promise<ResponseType<string>> => {
  try {
    const response = (
      await instance.put(
        `${emr.deleteMedicalHistory}${id}?clinicId=${clinicId}`
      )
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: "Something went wrong !",
    };
  }
};

export const getProcedureList = async (data: { encounterId: number }) => {
  try {
    const result = await instance.post(`${emr.getProcedures}`, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export type GetDrugsParams = {
  searchText: string;
  userId: number | null;
};

export const getDrugs = async ({
  searchText,
  userId,
}: GetDrugsParams): Promise<ResponseType<DrugType[]>> => {
  try {
    const userIdQuery = userId != null ? `&userId=${userId}` : "";
    const result = (
      await instance.get(
        `${emr.getDrugs}${clinicId}?searchText=${encodeURIComponent(searchText)}${userIdQuery}`,
      )
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export type AddDrugFavouriteParams = {
  drugId: number;
  userId: number;
  clinicId: number;
  isFavorite: 0 | 1;
};

export const addDrugFavourite = async (
  params: AddDrugFavouriteParams,
): Promise<ResponseType<unknown>> => {
  try {
    const response = await instance.post(emr.addPrescriptionFavourite, params);
    return response.data;
  } catch (error) {
    return emptyError;
  }
};

export const getUnit = async (
  text: string
): Promise<ResponseType<DrugunitType[]>> => {
  try {
    const result = (
      await instance.get(`${emr.getUnit}${clinicId}?searchText=${text}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const getFrequency = async (
  text: string
): Promise<ResponseType<DrugFrequencyType[]>> => {
  try {
    const result = (
      await instance.get(`${emr.getFrequency}${clinicId}?searchText=${text}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const getDosageTiming = async (
  text: string
): Promise<ResponseType<DosageTimingType[]>> => {
  try {
    const result = (
      await instance.get(`${emr.getDosageTiming}${clinicId}?searchText=${text}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const getRouteOfAdmin = async (
  text: string
): Promise<ResponseType<RouteOfAdminType[]>> => {
  try {
    const result = (
      await instance.get(`${emr.getRouteOfAdmin}${clinicId}?searchText=${text}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const getFamilyHistoryData = async (
  Id: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.getFamilyHistory}/${Id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getSocialHistoryData = async (
  Id: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.getSocialHistory}${Id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getAllergyData = async (
  Id: string
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.getAllergy}${Id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getDiagnosisData = async (
  Id: number
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.getDiagnosis}${Id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getDiagnosisList = async (
  id: string
): Promise<ResponseType<DiagnosisListType[]>> => {
  try {
    const result = await instance.get(
      `${emr.getEmrDiagnosis}${id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return {
      ...emptyError,
      response: [],
    };
  }
};

export const DeleteDiagnosis = async (data: {
  id: string;
  diagnosisId: number;
}): Promise<ResponseType<any | null>> => {
  try {
    const result = await instance.get(
      `${emr.deleteDiagnosis}${data.id}?clinicId=${clinicId}&diagnosisId=${data.diagnosisId}&createdById=${createdById}`
    );
    return result.data;
  } catch (error) {
    return { ...emptyError, response: [] };
  }
};

export const addFamilyHistory = async (
  data: PostFamilyHistoryType
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.PostFamilyHistory}`, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getLogsDetails = async ({
  field,
  encounterId,
}: {
  field: LogFieldType;
  encounterId: string;
}): Promise<ResponseType<LogResponseType[]>> => {
  try {
    const result = await instance.get(
      `${emr.revisionLog}${field}/${encounterId}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    console.log(error);

    return {
      ...emptyError,
      response: [],
    };
  }
};

export const getfamilyIcdDetails = async (
  data: string
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.getfamilyHistoryIcd}${clinicId}?searchText=${data}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPatientRelation = async (): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(`${emr.getPatientRelation}${clinicId}`);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getAllergyType = async (): Promise<
  ResponseType<AllergyDropdownType[] | null>
> => {
  try {
    const result = await instance.get(`${emr.getAllergyType}${clinicId}`);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getAllergen = async (
  typeId: number
): Promise<ResponseType<AllergenType[]>> => {
  try {
    const result = await instance.get(
      `${emr.getAllergen}${clinicId}?id=${typeId}`
    );
    return result.data;
  } catch (error) {
    return { ...emptyError, response: [] };
  }
};

export const getseverity = async (): Promise<
  ResponseType<AllergySeverityType[] | null>
> => {
  try {
    const result = await instance.get(`${emr.getAllergySeverity}${clinicId}`);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getAllergyStatus = async (): Promise<
  ResponseType<AllergyStatusType[] | null>
> => {
  try {
    const result = await instance.get(`${emr.getAllergyStatus}${clinicId}`);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const PostAllergy = async (
  data: postAllergy
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.postAllergy}`, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const DeleteAllergy = async ({
  encounterId,
  id,
}: {
  encounterId: string;
  id: any;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.deleteAllergy}${encounterId}?allergyId=${id}&clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const saveOrUpdatePrescription = async (
  data: Omit<
    PrescriptionPayloadType,
    "prescriptionClinicId" | "prescriptionCreatedById" | "userType"
  >
): Promise<ResponseType<any>> => {
  const body: PrescriptionPayloadType = {
    ...data,
    prescriptionClinicId: clinicId,
    userType,
    prescriptionCreatedById: createdById as number,
  };
  try {
    const result = (await instance.post(emr.saveprescription, body)).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const deletePrescription = async ({
  encounterId,
  id,
}: {
  encounterId: number;
  id: number;
}): Promise<ResponseType<any>> => {
  try {
    const result = (
      await instance.get(
        `${emr.deletePrescription}${encounterId}?clinicId=${clinicId}&prescriptionId=${id}`
      )
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getPrescription = async (
  id: string
): Promise<ResponseType<any>> => {
  try {
    const result = (
      await instance.get(`${emr.getPrescription}${id}?clinicId=${clinicId}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const submitErx = async (params: {
  encounterId: string;
  paymentType: number;
}): Promise<ResponseType<SubmitResponseType | null>> => {
  try {
    const response = (
      await instance.get(
        `${emr.submitErx}${clinicId}?encounterId=${params?.encounterId}&isProduction=true&paymentType=${params?.paymentType}`
      )
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getPrescriptionPrint = async ({
  encounterId,
  paymentMode,
  region
}: {
  encounterId: string;
  paymentMode: number;
  region?:string
}): Promise<ResponseType<any>> => {
  try {
    const response = (
      await instance.get(
        `${emr.prescriptionPrint}${encounterId}?clinicId=${clinicId}&paymentMode=${paymentMode}${region ? `&region=${region}` : ""}`
      )
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getPrescriptionClaimForm = async (
  EncounterId: number
): Promise<ResponseType<any>> => {
  try {
    const response = (
      await instance.get(
        `${emr.prescritionClaimForm}${EncounterId}?clinicId=${clinicId}`
      )
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

// CptRateType
export const getRateOfCpt = async (data: {
  cptId: number;
  encounter: number;
  cptGroupId: number;
  paymentMode: number;
}): Promise<ResponseType<CptInvestigationRateType | null>> => {
  const body = {
    clinicId,
    ...data,
  };
  try {
    const result = (await instance.post(`${emr.getInsRate}`, body)).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getPatientShare = async (
  params:
    | Omit<GetPatientShareParams, "clinicId">
    | Omit<FetchPatientShareParamType, "clinicId">
): Promise<ResponseType<GetPatientResponse | PatientRateType | null>> => {
  const body = {
    ...params,
    clinicId,
  };
  try {
    const result = (await instance.post(`${emr.getPatientShare}`, body)).data;
    return result;
  } catch (error) {
    return {
      ...sampleResult,
      response: null,
    };
  }
};

export const getLabList = async ({
  encounterId,
  status = 1,
}: GetLabPayloadType): Promise<
  ResponseType<{ totalCount: number; items: LabTableType[] }>
> => {
  const body = {
    encounterId,
    status,
    clinicId,
  };
  const result = await instance.post(`${emr.getLab}`, body);
  return result.data;
};

export const getRadiologyList = async ({
  encounterId,
  status = 1,
}: GetLabPayloadType): Promise<
  ResponseType<{ totalCount: number; items: RadiologyTableType[] }>
> => {
  const body = {
    clinicId,
    encounterId,
    status,
  };

  const result = await instance.post(`${emr.getRadiology}`, body);
  return result.data;
};

export const deleteFamilyHistory = async (data: {
  encounterId: string;
  id: number;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.deletFamilyHistory}/${data.encounterId}?clinicId=${clinicId}&familyHistoryId=${data.id}`
    );
    return result.data;
  } catch (error) {
    return { ...emptyError, response: [] };
  }
};

export const getSocialHabitCategory = async (): Promise<
  ResponseType<SocialHabitCategoryType[] | null>
> => {
  try {
    const result = await instance.get(
      `${emr.getSocialHabitCategory}${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getSocialHabitDescription = async (
  id: number
): Promise<ResponseType<snomedDescriptionType[] | null>> => {
  try {
    const result = await instance.get(
      `${emr.getSocialHabitDescription}${id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getSocialLifeCycleStatus = async (): Promise<
  ResponseType<LifeCycleStatusType[] | null>
> => {
  try {
    const result = await instance.get(`${emr.getLifeCycleStatus}`);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getSocialQuantity = async (
  id: number
): Promise<ResponseType<socialQuantityType[] | null>> => {
  try {
    const result = await instance.get(
      `${emr.getSocialQuantity}${id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const PostSocialHistoryData = async (
  data: postSocialHistoryType
): Promise<ResponseType<postSocialHistoryType | null>> => {
  try {
    const result = await instance.post(`${emr.postSocialHistory}`, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const deleteSocialHistory = async (data: {
  encounterId: string;
  id: number;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.deleteSocialHistory}${data.encounterId}?clinicId=${clinicId}&socialHistoryId=${data.id}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getDiagnosisforProblems = async (
  id: string
): Promise<ResponseType<DiagType[] | null>> => {
  try {
    const result = await instance.get(
      `${emr.getDiagnosis}${id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getproblemsofDiagnosis = async (
  searchText: string
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.problemsByDiagnosis}${clinicId}?searchText=${searchText}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const postProbelms = async (data: any): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${emr.postProblems}`, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const deleteProblems = async (data: any): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.deleteProblems}${data.encounterId}?clinicId=${clinicId}&problemId=${data.id}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getproblems = async (id: string): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${emr.getProblemsList}${id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getEmrList = async (
  data: EmrListParams
): Promise<ResponseType<EmrListResponseType>> => {
  const userloginid = user?.login_id;
  const body = {
    ...data,
    clinicId,
    userloginid,
  };
  const response = (await instance.post(`${emr.emrListv2}`, body)).data;
  return response;
};

// ----------------- managemen plan -----------------

export const getMangementPlan = async (
  id: string
): Promise<ResponseType<GetManagementPlanType>> => {
  try {
    const response = (
      await instance.get(`${emr.getManagementPlan}${id}?clinicId=${clinicId}`)
    ).data;
    return response;
  } catch (error) {
    return {
      ...sampleResult,
      response: {
        id: 0,
        managementPlan: "",
      },
    };
  }
};

export const getTreatmentPlan = async (
  id: string
): Promise<ResponseType<GetTretmantPlanType>> => {
  try {
    const response = (
      await instance.get(`${emr.getTreatmentPlan}${id}?clinicId=${clinicId}`)
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: {
        followUp: "",
        healthEducation: "",
        investigation: "",
        medication: "",
        id: 0,
      },
    };
  }
};
export const getClinicalImpression = async (
  id: string
): Promise<ResponseType<GetClinicalImpressionType>> => {
  try {
    const response = (
      await instance.get(
        `${emr.getClinicalImpression}${id}?clinicId=${clinicId}`
      )
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: {
        id: 0,
        clinicalImpression: "",
      },
    };
  }
};

export const postManagementPlan = async (
  params: ManagementPlanParamsType
): Promise<ResponseType<string>> => {
  const data: ManagementPlanSaveType = {
    ...params,
    createdById: createdById as number,
    clinicId,
    isModified: 0,
    userType,
  };

  try {
    const response = (await instance.post(emr.postManagementPlan, data)).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: "Something went wrong",
    };
  }
};
export const postTreatment = async (
  params: TreatmentPlanParamsType
): Promise<ResponseType<string>> => {
  const data: TreatmentPlanSaveType = {
    ...params,
    createdById: createdById as number,
    clinicId,
    isModified: 0,
    userType,
  };

  try {
    const response = (await instance.post(emr.postTreatmantPlan, data)).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: "Something went wrong",
    };
  }
};

export const postClinicalImpression = async (
  params: ClinicalImpresssionParamsType
): Promise<ResponseType<string>> => {
  const data: ClinicalImpressionSaveType = {
    ...params,
    createdById: createdById as number,
    clinicId,
    isModified: 0,
    userType,
  };

  try {
    const response = (await instance.post(emr.postClinicalImpression, data))
      .data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: "Something went wrong",
    };
  }
};

export const submitEmrService = async (
  params: submitEmrType
): Promise<ResponseType<any | null>> => {
  const response = (await instance.post(emr.submitEmr, params)).data;
  return response;
};

export type TreatmentEstimateResponse = {
  invoice: string;
};

export const sendTreatmentEstimate = async (params: {
  clinicId: number;
  encounterId: number;
}): Promise<ResponseType<TreatmentEstimateResponse | null>> => {
  const response = (
    await instance.get(
      `${emr.sendTreatmentEstimate}${params.clinicId}?id=${params.encounterId}`,
    )
  ).data;
  return response;
};

export type TelemedicineProvider = "GOOGLE" | "ZOOM";

export type TelemedicinePayload = {
  appointmentId: string;
  patientName: string;
  patientEmail: string;
  doctorEmail: string;
  startTime: string;
  endTime: string;
  timeZone: string;
  provider: TelemedicineProvider;
};

export type TelemedicineResponse = {
  provider: TelemedicineProvider;
  meetingId: string;
  joinUrl: string;
  hostUrl: string | null;
};

export const createTelemedicine = async (
  payload: TelemedicinePayload,
): Promise<ResponseType<TelemedicineResponse | null>> => {
  const response = (await instance.post(emr.telemedicine, payload)).data;
  return response;
};

export const consultationStartService = async (params: {
  encounterId: number;
  destination: string;
  sourceDateTime?: string;
}): Promise<ResponseType<any>> => {
  try {
    const response = (
      await instance.post(emr.consultationStart, params)
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const updateReviewService = async (params: {
  encounterId: number;
  reviewRemarks: string;
  reviewDateTime: string;
}): Promise<ResponseType<any>> => {
  try {
    const response = (
      await instance.patch(
        `${emr.updateReview}?encounterId=${params.encounterId}&reviewRemarks=${encodeURIComponent(
          params.reviewRemarks,
        )}&reviewDateTime=${encodeURIComponent(params.reviewDateTime)}`,
      )
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

// export const getPriorAprovals = async (
//   id: string
// ): Promise<ResponseType<PriorApprovalLisType[]>> => {
//   try {
//     const result = await ({
//       endPoint: `${emr.getPriorApproval}${id}?access_token=${access_token}`,
//       method: "get",
//     });
//     return {
//       ...sampleResult,
//       response: result || [],
//     };
//   } catch (error) {
//     return {
//       ...errorResponse,
//       response: [],
//     };
//   }
// };

export const submitPriorApproval = async (
  params: PriorApprovalSubmitParamsType[]
): Promise<ResponseType<any>> => {
  try {
    const response = (await instance.post(emr.submitPriorApproval, params, {}))
      .data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: "Something went wrong !",
    };
  }
};

export const viewVitals = async (
  id: string
): Promise<ResponseType<ViewVitalsType | null>> => {
  try {
    const response = (
      await instance.get(`${emr.viewVitas}${id}?clinicId=${clinicId}`)
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const saveSecondMedicalHistory = async (
  params: SecondMedicalHistoryFormType
): Promise<ResponseType<SecondSaveType | null>> => {
  const data: SecondSaveType = {
    ...params,
    clinicId,
    isModified: 0,
    createdById: createdById as number,
    status: 1,
    userType,
    revertFlag: false,
  };
  try {
    const response = (await instance.post(emr.postSecondMedicalHistory, data))
      .data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getSecondMedicalHistory = async (
  id: string
): Promise<ResponseType<SecondSaveType | null>> => {
  try {
    const response = (
      await instance.get(
        `${emr.getSecondMedicalHistory}${id}?clinicId=${clinicId}`
      )
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getDisease = async (
  text: string
): Promise<ResponseType<DiseaseType[]>> => {
  try {
    const response = (
      await instance.get(`${emr.getAllDisease}${clinicId}?code=${text}`)
    ).data;
    return response;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

// export const getMedicalHistoryLog = async (
//   id: string
// ): Promise<ResponseType<MedicalHistoryLogType[]>> => {
//   try {
//     const result = await ({
//       endPoint: `${emr.getHistoryDetailsRevisionLog}${id}?access_token=${access_token}`,
//       method: "get",
//     });
//     return {
//       ...sampleResult,
//       response: result || [],
//     };
//   } catch (error) {
//     return {
//       ...errorResponse,
//       response: [],
//     };
//   }
// };

export const postActivity = async (
  params: ActivityPostParamsType
): Promise<ResponseType<null>> => {
  const body: ActivityPostType = {
    ...params,
    clinicId,
    createdById: createdById as number,
  };
  try {
    const reponse = (await instance.post(`${emr.postActiviy}`, body)).data;
    return reponse;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getActivityList = async (
  params: Omit<ActivityListParamsType, "clinicId">
): Promise<ResponseType<{ totalCount: number; list: ActivityList[] }>> => {
  const body: ActivityListParamsType = {
    ...params,
    clinicId,
  };
  try {
    const result = (await instance.post(emr.activityList, body)).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: { totalCount: 0, list: [] },
    };
  }
};

export const viewActivityFile = async (
  data: ViewFileParamsType
): Promise<ResponseType<ViewFileResultType | null>> => {
  const result = await instance.post(`${emr.viewActivityFile}`, data);
  return result.data;
};

export const SaveDentalProcedure = async (
  data: any
): Promise<ResponseType<any | null>> => {
  try {
    const result = await instance.post(`${emr.saveDental}`, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getDentalCpt = async (  data: DentalCptPayload & {codetype:string;insname:string | null}
): Promise<ResponseType<dentaCptDetailsType[] | null>> => {
  try {
    const result = await instance.post(data.codetype== "CPT" ? `${emr.activitySearch}` : `${emr.activitySearchv2}`, data);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const GetDentalDetailsList = async (
  encounterId: number
): Promise<ResponseType<DentalRecords | null>> => {
  try {
    const result = await instance.get(
      `${emr.getDentalList}${encounterId}?clinicId=1`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

// Define the shape of the payload
interface DentalListPayload {
  encounterId: number;
  clinicId: number;
  insname: string;
}

export const GetDentalDetailsListV2 = async (
  payload: DentalListPayload
): Promise<ResponseType<DentalRecords | null>> => {
  try {
    // We send the payload object directly as the second argument
    const result = await instance.post(
      `${emr.getDentalListV2}`, 
      payload 
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const deleteDentalProceure = async (
  toothId: number
): Promise<ResponseType<any | null>> => {
  try {
    const result = await instance.get(
      `${emr.deleteDental}${toothId}?clinicId=1`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getDocumentTypes = async (): Promise<
  ResponseType<DocumentDropdownType[] | null>
> => {
  try {
    const result = (await instance.get(`${emr.getDocumentTypes}${clinicId}`))
      .data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const saveDocument = async (
  params: SaveDocumentPayloadType
): Promise<ResponseType<any>> => {
  const { details, file } = params;
  const data = JSON.stringify({
    ...details,
    clinicId,
    createdById,
  });
  const formData = new FormData();
  formData.append("data", data);
  formData.append("file", file);
  try {
    const result = (await instance.post(emr.saveDocument, formData)).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getUploadedDocuments = async (
  id: string
): Promise<ResponseType<DocumentsListType[]>> => {
  try {
    const result = (
      await instance.get(
        `${emr.getUploadedDocumentList}${id}?clinicId=${clinicId}`
      )
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};

export const deleteDocument = async (
  id: number
): Promise<ResponseType<null | Blob>> => {
  try {
    const result = (
      await instance.get(`${emr.deleteDocument}${id}?clinicId=${clinicId}`)
    ).data;
    return result;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getInsuranceCptRate = async (data: {
  encounter: number;
  clinicId: number;
  cptId: number;
  cptGroupId: number;
  paymentMode: number;
}): Promise<ResponseType<any>> => {
  try {
    const response = await instance.post(
      `${emr.getInsRate}?access_token=${access_token}`,
      data
    );
    return response.data;
  } catch (error) {
    return emptyError;
  }
};

export const getInsurancePatientShare = async (data: {
  cptId: number;
  amount: number;
  qty: number;
  encounter: number;
  cptGroupId: number;
  id: number;
  clinicId: number;
  editFlag: number;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(
      `${emr.getInsurancePatientShare}?access_token=${access_token}`,
      data
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const activitySearch = async (
  params: ActivitySearchParamsType & { insname?: string | null, codetype?: string }
): Promise<ResponseType<ActivitySearchResponseType[]>> => {
  const response = await instance.post(params.codetype == "INTERNAL" ? emr.activitySearchv2 : emr.activitySearch , {
    clinicId,
    userGroup: userType,
    ...params,
  });
  return response.data;
};

export type AddCptFavouriteParams = {
  cptId: number;
  userId: number;
  clinicId: number;
  isFavorite: 0 | 1;
};

export const addCptFavourite = async (
  params: AddCptFavouriteParams,
): Promise<ResponseType<unknown>> => {
  try {
    const response = await instance.post(emr.addCptFavourite, params);
    return response.data;
  } catch (error) {
    return emptyError;
  }
};

export const saveActivity = async ({
  fromVerification,
  labDetailsDto = null,
  procedureDetailsDto = null,
  radiologyDetailsDto = null,
}: {
  fromVerification?: boolean;
  labDetailsDto?: LabType | null;
  radiologyDetailsDto?: RadiologyType | ProcedureType | null;
  procedureDetailsDto?: ProcedureType | null;
}): Promise<ResponseType<any>> => {
  const response = await instance.post(emr.activitySave, {
    fromVerification,
    labDetailsDto,
    procedureDetailsDto,
    radiologyDetailsDto,
  });
  return response.data;
};

export const deleteActivity = async (params: {
  activityId: number;
  cptGrpId: number;
  encounterId: number;
  paymentMode: number;
}): Promise<ResponseType<any>> => {
  const response = await instance.post(emr.deleteActivity, {
    ...params,
    clinicId,
  });
  return response.data;
};

export const getAllHIstory = async ({
  id,
  tab,
}: {
  id: number;
  tab: string;
}): Promise<ResponseType<any>> => {
  const body = {
    clinicId: clinicId,
    patientMasterId: id,
    tab: tab,
  };
  const result = await instance.post(MastersApi.getPreviousHistory, body);
  return result.data;
};

export const setPackageToUser = async (payload: {
  clinicId: number | string;
  packageId: number | string | null;
  encounterId: number | string;
  createdById:number | string;
}): Promise<ResponseType<any>> => {
  const result = await instance.post(MastersApi.setPackage, payload);
  return result.data;
};

export const deletePackageToUser = async (payload: {
  clinicId: number | string;
  packageId: number | string | null;
  encounterId: number | string;
  createdById:number | string;
}): Promise<ResponseType<any>> => {
  const result = await instance.delete(`${MastersApi.deletePackage}/${payload.clinicId}?packageId=${payload.packageId}&encounterId=${payload.encounterId}`);
  return result.data;
};

export const getPatientJourney = async (
  encounterId: number
): Promise<ResponseType<any>> => {
  const result = await instance.get(`${emr.journeyOfEncounter}/${encounterId}`);
  return result.data;
};

export const getPatientJourneyOfEncounters = async (
  encounterIds: number[]
): Promise<ResponseType<any>> => {
  const result = await instance.post(`${emr.journeyOfEncounters}`, {
    encounterIds,
  });
  return result.data;
};



